export enum LogEntryMethod {
  Driver = 0,
  None = 1,
  Schedule = 2,
  DriverAndSchedule = 3,
  LiveDispatch = 4
}

export const LogEntryMethodMapping: Record<LogEntryMethod, string> = {
  [LogEntryMethod.Driver]: 'Driver',
  [LogEntryMethod.None]: 'No Entering',
  [LogEntryMethod.Schedule]: 'Schedule',
  [LogEntryMethod.DriverAndSchedule]: 'Driver and Schedule',
  [LogEntryMethod.LiveDispatch]: 'Live Dispatch'
};
